import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GLOBAL } from 'src/app/services/global';

@Component({
  selector: 'app-aux-url-inspeccion',
  templateUrl: './aux-url-inspeccion.component.html',
  styleUrls: ['./aux-url-inspeccion.component.css']
})
export class AuxUrlInspeccionComponent implements OnInit {
  constructor(private dialog: MatDialog, private _router:Router) { }
  public nombreMuni = GLOBAL.nombreMuni;
  public filedomSolicitudUrl = GLOBAL.filedomSolicitudUrl;
  public filedomSeguimientoUrl = GLOBAL.filedomSeguimientoUrl;
  public seguimientoCertificados = GLOBAL.seguimientoCertificados;
  
  ngOnInit(): void {
  }


abrirInspeccion(){
  console.log('===ABRIR INGRESO ====');

  this._router.navigate(['/inspeccion']); 
  this.dialog.closeAll();

}
  
}
